import $ from 'jquery'
import RemoteForm from '../shared/remote-form'
import 'owl.carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import PhonePlaceholder from '../shared/phone.placeholder'
import TimeRemaining from '../shared/time.remaining'

let initializeAjaxForm = () => {
  window.remote_form = new RemoteForm()
}

let initializeTimeRemaining = () => {
  $('.JS-TimeRemaining').each(function() {
    new TimeRemaining($(this)) // eslint-disable-line no-new
  })
}

$(() => {
  initializeAjaxForm()
  initializeTimeRemaining()

  $('.js-slider').owlCarousel({
    nav: false,
    dotsContainer: '.js-slider-dots',
    loop: true,
    items: 1,
    scroll: 1,
    autoplay: true,
    autoplayTimeout: 5000
  })

  let $cntSlider = $('.js-result-slider')
  let $thumbslider = $('.js-thumb-slider')

  $cntSlider.owlCarousel({
    items: 1,
    loop: true,
    mouseDrag: false
  })

  $thumbslider.owlCarousel({
    items: 3,
    scroll: 1,
    nav: false,
    slideSpeed: 800,
    loop: true,
    center: true,
    touchDrag: false,
    mouseDrag: false,
    responsive: {
      0: { items: 1 },
      1025: { items: 3 }
    }
  })

  $thumbslider.find('.owl-item').on('click', function() {
    if (!$(this).hasClass('center')) {
      if (
        $(this)
          .next()
          .hasClass('center')
      ) {
        $thumbslider.trigger('prev.owl.carousel', [300])
        $cntSlider.trigger('prev.owl.carousel', [300])
      } else {
        $thumbslider.trigger('next.owl.carousel', [300])
        $cntSlider.trigger('next.owl.carousel', [300])
      }
    }
  })

  $('.js-thumb-prev').click(function() {
    $cntSlider.trigger('prev.owl.carousel', [300])
    $thumbslider.trigger('prev.owl.carousel', [300])
  })

  $('.js-thumb-next').click(function() {
    $cntSlider.trigger('next.owl.carousel', [300])
    $thumbslider.trigger('next.owl.carousel', [300])
  })

  // MOBILE MENU
  $('.js-humb').click(function() {
    $(this).toggleClass('humb_on')
    $('.js-nav').toggleClass('header-nav_open')
  })

  $(document).mouseup((e) => {
    let container = $('.js-header')
    if (container.has(e.target).length === 0) {
      $('.js-humb').removeClass('humb_on')
      $('.js-nav').removeClass('header-nav_open')
    }
  })

  $('.JS-PhonePlaceholder').each((index, el) => {
    new PhonePlaceholder($(el)) // eslint-disable-line no-new
  })

  $('.JS-CaseGallery-fancy').each((index, el) => {
    let $fancy = $(el)
    let timerId = null
    $fancy.fancybox({
      afterShow: () => {
        timerId = setInterval(() => $fancy.resize(), 500)
      },
      beforeClose: () => clearInterval(timerId)
    })
  })
  $('.JS-CaseGallery').each((index, el) => {
    let $el = $(el)
    let id = $el.data('id')

    $el.owlCarousel({
      nav: true,
      items: 1,
      scroll: 1,
      navContainer: '#case-gallery-nav-' + id,
      dotsContainer: '#case-gallery-dots-' + id,
      navText: ''
    })
  })

  $('.fancy').fancybox()

  // map
  if (document.getElementById('map-canvas')) {
    let GoogleMaps = window.google.maps
    const initialize = function() {
      let mapOptions = {
        zoom: 17,
        center: new GoogleMaps.LatLng(55.807942, 37.513332),
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        draggable: true,
        mapTypeId: GoogleMaps.MapTypeId.ROADMAP
      }
      let map = new GoogleMaps.Map(document.getElementById('map-canvas'), mapOptions)
      let myLatLng = new GoogleMaps.LatLng(55.807942, 37.511832)
      let markerParameters = {
        position: myLatLng,
        map: map
      }
      new GoogleMaps.Marker(markerParameters) // eslint-disable-line no-new
    }
    GoogleMaps.event.addDomListener(window, 'load', initialize)
  }
})
